import { v4 as uuidv4 } from 'uuid';

import { SearchParameters, SearchResultType } from '../../state/types';
import { reportSearchBegin, reportThreadSearchSubmitted } from '../../telemetry/report/protobuf/events';
import { GenericThunkAction } from '../../types';
import { findById as findGroup } from '../groups/selectors';

import { getSearchSessionConversationId, getSearchSessionConversationStart } from './selectors';
import { SearchSessionActivateSearchBoxAction, SearchSessionEndAction, SearchSessionSubmitSearchAction } from './types';

type SubmitSearch = (searchParameters: SearchParameters) => GenericThunkAction<SearchSessionSubmitSearchAction>;
export const submitSearch: SubmitSearch =
  ({ searchText, endTimestamp, startTimestamp, resultType, groupScope: groupId }) =>
  (dispatch, getState) => {
    const state = getState();
    const logicalId = uuidv4();

    if (
      resultType === SearchResultType.Thread ||
      resultType === SearchResultType.Inbox ||
      resultType === SearchResultType.NetworkQuestion
    ) {
      const conversationId = getSearchSessionConversationId(state);
      const groupTelemetryId = groupId ? findGroup(state, groupId)?.telemetryId : undefined;
      const length = searchText.length;
      const wordCount = searchText.split(' ').filter((word) => word !== '').length;
      const conversationStart = getSearchSessionConversationStart(state);

      reportThreadSearchSubmitted({
        logicalId,
        conversationId,
        queryLength: length,
        dateFilterStartTimestamp: startTimestamp,
        dateFilterEndTimestamp: endTimestamp,
        resultType,
        groupTelemetryId,
        wordCount,
        conversationStart,
      });
    }

    return dispatch({
      type: 'SEARCH.SUBMIT',
      payload: {
        logicalId,
      },
    });
  };

type ActivateSearchBox = (
  currentSearchBoxText: string | undefined,
  beganSearchFrom: string,
  language: string
) => GenericThunkAction<SearchSessionActivateSearchBoxAction>;
export const activateSearchBox: ActivateSearchBox = (currentSearchBoxText, beganSearchFrom, language) => (dispatch) => {
  const conversationId = uuidv4();
  const logicalId = uuidv4();
  const conversationStart = Date.now();
  const isRefinement = !!currentSearchBoxText?.length;

  reportSearchBegin({
    conversationId,
    beganSearchFrom,
    isRefinement,
    language,
  });

  return dispatch({
    type: 'SEARCH.ACTIVATE_SEARCHBOX',
    payload: {
      conversationId,
      conversationStart,
      logicalId,
    },
  });
};

type EndSearchSession = () => SearchSessionEndAction;
export const endSearchSession: EndSearchSession = () => ({
  type: 'SEARCH.END_SESSION',
});
